(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  /* ==========================================================
     ANTI-FLASH SÉCURISÉ DU MEGAMENU
     ========================================================== */
  (function () {
    'use strict';

    var SAFETY_TIMEOUT_MS = 250;

    function hasMegamenuContent(item) {
      return !!item.querySelector(
        '[class*="megamenu__panel"], [class*="megamenu-panel"], [class*="mega-menu__panel"], ' +
        '[class*="megamenu__columns"], [class*="megamenu__grid"], [class*="megamenu-columns"]'
      );
    }

    function flagMegamenuItem(item) {
      if (item.dataset.azMmFlagged === '1') return;
      item.dataset.azMmFlagged = '1';
      item.classList.add('az-mm-flagged');

      var pendingTimeout = null;

      var observer = new MutationObserver(function () {
        var isOpen = item.getAttribute('data-open') === 'true';

        if (isOpen) {
          if (hasMegamenuContent(item)) {
            item.classList.add('az-mm-ready');
            if (pendingTimeout) {
              clearTimeout(pendingTimeout);
              pendingTimeout = null;
            }
          } else {
            if (pendingTimeout) clearTimeout(pendingTimeout);
            pendingTimeout = setTimeout(function () {
              item.classList.add('az-mm-ready');
              pendingTimeout = null;
            }, SAFETY_TIMEOUT_MS);

            requestAnimationFrame(function () {
              if (hasMegamenuContent(item)) {
                item.classList.add('az-mm-ready');
                if (pendingTimeout) {
                  clearTimeout(pendingTimeout);
                  pendingTimeout = null;
                }
              }
            });
          }
        } else {
          item.classList.remove('az-mm-ready');
          if (pendingTimeout) {
            clearTimeout(pendingTimeout);
            pendingTimeout = null;
          }
        }
      });

      observer.observe(item, {
        attributes: true,
        attributeFilter: ['data-open'],
        childList: true,
        subtree: true
      });
    }

    function flagAllMegamenuItems() {
      var items = document.querySelectorAll('.header__menu-item--megamenu');
      Array.prototype.forEach.call(items, flagMegamenuItem);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', flagAllMegamenuItems);
    } else {
      flagAllMegamenuItems();
    }

    if (typeof MutationObserver !== 'undefined') {
      var globalObserver = new MutationObserver(function (mutations) {
        var needsScan = false;
        for (var i = 0; i < mutations.length; i++) {
          if (mutations[i].addedNodes && mutations[i].addedNodes.length > 0) {
            needsScan = true;
            break;
          }
        }
        if (needsScan) flagAllMegamenuItems();
      });
      globalObserver.observe(document.body, { childList: true, subtree: true });
    }
  })();

  /* ==========================================================
     MARQUAGE FIABLE DES TITRES DE COLONNES DU MÉGAMENU
     ==========================================================
     Cette version ne dépend plus de la structure HTML du thème.
     Elle lit les titres de niveau 2 depuis le menu Shopify, puis
     cherche ces textes dans le mégamenu desktop, même si le panneau
     est encore caché. Les styles sont appliqués en inline + classe
     pour passer au-dessus des règles du thème.
     ========================================================== */
  (function () {
    'use strict';

    var TITLE_CLASS = 'az-megamenu-col-title';
    var SUBLINK_CLASS = 'az-megamenu-sub-link';
    var TITLE_ATTR = 'data-az-megamenu-title';
    var SUBLINK_ATTR = 'data-az-megamenu-sub-link';
    var STYLE_ATTR = 'data-az-megamenu-inline-style';
    var scanTimer = null;
    var titleDataCache = null;

    function toArray(list) {
      return Array.prototype.slice.call(list || []);
    }

    function normalizeText(value) {
      var text = String(value || '')
        .replace(/[\u200B-\u200D\uFEFF]/g, '')
        .replace(/[›→]/g, '')
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();

      try {
        text = text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      } catch (e) {}

      return text;
    }

    function normalizeUrl(value) {
      if (!value || value === '#') return '';

      var a = document.createElement('a');
      a.href = value;

      var path = a.pathname || '';
      path = path.replace(/\/$/, '');
      if (path === '') path = '/';

      return path + (a.search || '');
    }

    function readTitleData() {
      var sources = toArray(document.querySelectorAll('[data-az-megamenu-title-source] [data-title]'));
      var byTitle = {};
      var unique = [];
      var seen = {};

      sources.forEach(function (source) {
        var title = source.getAttribute('data-title') || '';
        var url = source.getAttribute('data-url') || '';
        var key = normalizeText(title);
        var urlKey = normalizeUrl(url);

        if (!key) return;

        var id = key + '|' + urlKey;
        if (seen[id]) return;
        seen[id] = true;

        var item = {
          title: title,
          key: key,
          url: url,
          urlKey: urlKey
        };

        unique.push(item);
        if (!byTitle[key]) byTitle[key] = [];
        byTitle[key].push(item);
      });

      titleDataCache = {
        list: unique,
        byTitle: byTitle
      };

      return titleDataCache;
    }

    function getTitleData() {
      return titleDataCache || readTitleData();
    }

    function getCleanText(el) {
      return String(el && el.textContent ? el.textContent : '')
        .replace(/[\u200B-\u200D\uFEFF]/g, '')
        .replace(/\s+/g, ' ')
        .trim();
    }

    function getStyleTarget(el) {
      if (!el) return null;

      var interactive = el.closest('a, button, summary, [role="link"]');
      if (interactive && interactive.closest('header-component .header__layout-desktop')) {
        return interactive;
      }

      return el;
    }

    function isExcluded(el) {
      return !el || !!el.closest(
        '#az-mobile-drawer, ' +
        '.header__layout-mobile, ' +
        '.header__actions, ' +
        '.header__logo, ' +
        '.search-popup-mobile, ' +
        '.localization-form, ' +
        '[data-az-megamenu-title-source]'
      );
    }

    function hasDropdownContext(el) {
      var menu = el.closest('header-component .header__menu-desktop');
      if (!menu) return false;

      var node = el;
      while (node && node !== menu) {
        var className = typeof node.className === 'string' ? node.className : '';
        if (/mega|megamenu|mega-menu|submenu|dropdown|panel|popover|columns|column|grid|content/i.test(className)) return true;
        if (node.getAttribute && node.getAttribute('data-open') === 'true') return true;
        node = node.parentElement;
      }

      return false;
    }

    function listDepthInsideDesktopMenu(el) {
      var menu = el.closest('header-component .header__menu-desktop');
      var depth = 0;
      var node = el.parentElement;

      while (node && node !== menu) {
        if (node.tagName && /^(UL|OL)$/i.test(node.tagName)) depth += 1;
        node = node.parentElement;
      }

      return depth;
    }

    function isProbablyTopLevelTrigger(el) {
      var menu = el.closest('header-component .header__menu-desktop');
      if (!menu) return false;

      // Un lien au niveau de la barre principale ne doit jamais être stylé
      // comme titre de colonne. Les titres du mégamenu sont soit dans un
      // contexte dropdown/mega, soit plus profonds dans les listes.
      return !hasDropdownContext(el) && listDepthInsideDesktopMenu(el) <= 1;
    }

    function elementUrlKey(el) {
      var link = null;

      if (el.matches && el.matches('a[href]')) {
        link = el;
      } else {
        link = el.closest ? el.closest('a[href]') : null;
      }

      return link ? normalizeUrl(link.getAttribute('href')) : '';
    }

    function matchesKnownColumnTitle(el) {
      var data = getTitleData();
      var textKey = normalizeText(getCleanText(el));
      var matches = data.byTitle[textKey];

      if (!matches || !matches.length) return false;

      // Si le texte est unique dans le menu, le texte suffit. Si le même titre
      // existe plusieurs fois, on utilise l'URL quand elle est disponible.
      if (matches.length === 1) return true;

      var hrefKey = elementUrlKey(el);
      if (!hrefKey) return true;

      return matches.some(function (item) {
        return !item.urlKey || item.urlKey === hrefKey;
      });
    }

    function setImportant(el, property, value) {
      el.style.setProperty(property, value, 'important');
    }

    function applyTitleInlineStyle(el) {
      if (!el || el.getAttribute(TITLE_ATTR) === 'true') return;

      el.classList.add(TITLE_CLASS);
      el.setAttribute(TITLE_ATTR, 'true');
      el.setAttribute(STYLE_ATTR, 'true');

      setImportant(el, 'position', 'relative');
      setImportant(el, 'display', 'block');
      setImportant(el, 'width', '100%');
      setImportant(el, 'box-sizing', 'border-box');
      setImportant(el, 'text-transform', 'uppercase');
      setImportant(el, 'letter-spacing', '0.15em');
      setImportant(el, 'font-weight', '800');
      setImportant(el, 'font-size', '0.84rem');
      setImportant(el, 'line-height', '1.35');
      setImportant(el, 'color', 'var(--header-text-color)');
      setImportant(el, 'background-color', 'rgba(138, 43, 76, 0.11)');
      setImportant(
        el,
        'background-image',
        'linear-gradient(135deg, color-mix(in srgb, var(--header-text-color) calc(var(--az-megamenu-title-highlight, 14%) + 10%), transparent) 0%, color-mix(in srgb, var(--header-border-color) calc(var(--az-megamenu-title-highlight, 14%) + 12%), transparent) 100%)'
      );
      setImportant(el, 'padding', '0.72rem 0.95rem');
      setImportant(el, 'margin', '0 0 1.35rem 0');
      setImportant(el, 'border-radius', '10px');
      setImportant(el, 'border-left', '4px solid var(--header-text-color)');
      setImportant(el, 'box-shadow', '0 5px 14px -8px rgba(0, 0, 0, 0.20)');
      setImportant(el, 'white-space', 'normal');
      setImportant(el, 'overflow-wrap', 'break-word');
      setImportant(el, 'word-break', 'normal');
      setImportant(el, 'text-decoration', 'none');
      setImportant(el, 'isolation', 'isolate');
    }

    function applySubLinkClassFromColumn(titleEl) {
      var owner = titleEl ? titleEl.parentElement : null;
      if (!owner) return;

      var links = toArray(owner.querySelectorAll('a, button, summary, [role="link"]'));
      if (links.length <= 1) return;

      links.forEach(function (link) {
        if (link === titleEl) return;
        if (link.getAttribute(TITLE_ATTR) === 'true') return;
        if (isExcluded(link)) return;

        link.classList.add(SUBLINK_CLASS);
        link.setAttribute(SUBLINK_ATTR, 'true');
      });
    }

    function directTitleCandidate(owner) {
      if (!owner || !owner.children) return null;

      for (var i = 0; i < owner.children.length; i++) {
        var child = owner.children[i];
        var tag = child.tagName ? child.tagName.toLowerCase() : '';

        if (/^(a|button|summary|h1|h2|h3|h4|h5|h6|span|strong|b)$/i.test(tag)) {
          return getStyleTarget(child);
        }

        var nested = child.querySelector && child.querySelector('a, button, summary, [role="link"], h1, h2, h3, h4, h5, h6, span, strong, b');
        if (nested) return getStyleTarget(nested);
      }

      return null;
    }

    function markStructuralFallback(root) {
      var scope = root || document;
      var owners = toArray(scope.querySelectorAll(
        'header-component .header__layout-desktop [class*="mega"] li, ' +
        'header-component .header__layout-desktop [class*="megamenu"] li, ' +
        'header-component .header__layout-desktop [class*="mega-menu"] li, ' +
        'header-component .header__layout-desktop [class*="submenu"] li, ' +
        'header-component .header__layout-desktop [class*="dropdown"] li, ' +
        'header-component .header__layout-desktop [class*="panel"] li, ' +
        'header-component .header__layout-desktop [class*="columns"] > *, ' +
        'header-component .header__layout-desktop [class*="Columns"] > *, ' +
        'header-component .header__layout-desktop [class*="grid"] > *, ' +
        'header-component .header__layout-desktop [class*="Grid"] > *'
      ));

      owners.forEach(function (owner) {
        if (isExcluded(owner)) return;

        var linkCount = owner.querySelectorAll ? owner.querySelectorAll('a, button, summary, [role="link"]').length : 0;
        var hasNestedList = !!(owner.querySelector && owner.querySelector('ul, ol'));
        var className = typeof owner.className === 'string' ? owner.className : '';
        var looksLikeColumn = /column|Column|col-|grid|Grid/i.test(className);

        if (linkCount < 2 && !looksLikeColumn) return;
        if (!hasNestedList && !looksLikeColumn) return;

        var title = directTitleCandidate(owner);
        if (!title || isExcluded(title)) return;
        if (isProbablyTopLevelTrigger(title)) return;

        applyTitleInlineStyle(title);
        applySubLinkClassFromColumn(title);
      });
    }

    function markKnownTitles(root) {
      var scope = root || document;
      var selectors = [
        'header-component .header__layout-desktop a',
        'header-component .header__layout-desktop button',
        'header-component .header__layout-desktop summary',
        'header-component .header__layout-desktop [role="link"]',
        'header-component .header__layout-desktop h1',
        'header-component .header__layout-desktop h2',
        'header-component .header__layout-desktop h3',
        'header-component .header__layout-desktop h4',
        'header-component .header__layout-desktop h5',
        'header-component .header__layout-desktop h6',
        'header-component .header__layout-desktop span',
        'header-component .header__layout-desktop strong',
        'header-component .header__layout-desktop b'
      ].join(',');

      var seen = [];

      toArray(scope.querySelectorAll(selectors)).forEach(function (node) {
        var target = getStyleTarget(node);
        if (!target || seen.indexOf(target) !== -1) return;
        seen.push(target);

        if (isExcluded(target)) return;
        if (!matchesKnownColumnTitle(target)) return;

        applyTitleInlineStyle(target);
        applySubLinkClassFromColumn(target);
      });
    }

    function scanMegamenuTitles(root) {
      readTitleData();
      markKnownTitles(root || document);
      markStructuralFallback(root || document);
    }

    function scheduleScan(root) {
      if (scanTimer) clearTimeout(scanTimer);

      scanTimer = setTimeout(function () {
        scanMegamenuTitles(root || document);

        setTimeout(function () { scanMegamenuTitles(root || document); }, 120);
        setTimeout(function () { scanMegamenuTitles(root || document); }, 450);
      }, 20);
    }

    function initMegamenuTitleMarker() {
      scheduleScan(document);

      document.addEventListener('mouseover', function (event) {
        var item = event.target.closest('header-component .header__menu-desktop, header-component [data-open], header-component [class*="mega"], header-component [class*="submenu"], header-component [class*="dropdown"]');
        if (item) scheduleScan(item.closest('header-component') || document);
      }, true);

      document.addEventListener('focusin', function (event) {
        var item = event.target.closest('header-component .header__menu-desktop, header-component [data-open], header-component [class*="mega"], header-component [class*="submenu"], header-component [class*="dropdown"]');
        if (item) scheduleScan(item.closest('header-component') || document);
      }, true);

      document.addEventListener('shopify:section:load', function () {
        titleDataCache = null;
        scheduleScan(document);
      });

      if (typeof MutationObserver !== 'undefined') {
        var observer = new MutationObserver(function (mutations) {
          var shouldScan = false;

          for (var i = 0; i < mutations.length; i++) {
            if (mutations[i].type === 'childList' && (mutations[i].addedNodes.length || mutations[i].removedNodes.length)) {
              shouldScan = true;
              break;
            }

            if (mutations[i].type === 'attributes') {
              var name = mutations[i].attributeName;
              if (name === 'data-open' || name === 'class' || name === 'style' || name === 'hidden' || name === 'aria-hidden') {
                shouldScan = true;
                break;
              }
            }
          }

          if (shouldScan) scheduleScan(document);
        });

        observer.observe(document.body, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['data-open', 'class', 'style', 'hidden', 'aria-hidden']
        });
      }

      window.addEventListener('load', function () { scheduleScan(document); });
      window.addEventListener('resize', function () { scheduleScan(document); });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initMegamenuTitleMarker);
    } else {
      initMegamenuTitleMarker();
    }
  })();

  /* ==========================================================
     DRAWER MOBILE CUSTOM
     ========================================================== */
  (function () {
    'use strict';

    function initAzDrawer() {
      var drawer = document.getElementById('az-mobile-drawer');
      if (!drawer || drawer.dataset.azInit === '1') return;
      drawer.dataset.azInit = '1';

      var titleEl = drawer.querySelector('[data-az-title]');
      var backBtn = drawer.querySelector('[data-az-back]');
      var pages = drawer.querySelectorAll('[data-page]');
      var stack = ['root'];

      function findPage(id) {
        return drawer.querySelector('[data-page="' + id + '"]');
      }

      function updateUI() {
        var currentId = stack[stack.length - 1] || 'root';
        var currentPage = findPage(currentId);

        Array.prototype.forEach.call(pages, function (p) {
          var id = p.getAttribute('data-page');
          if (id === currentId) {
            p.setAttribute('data-active', 'true');
            p.classList.remove('is-pushed-back');
          } else {
            p.removeAttribute('data-active');
            if (stack.indexOf(id) !== -1) {
              p.classList.add('is-pushed-back');
            } else {
              p.classList.remove('is-pushed-back');
            }
          }
        });

        if (currentPage && titleEl) {
          titleEl.textContent = currentPage.getAttribute('data-page-title') || 'Menu';
        }

        if (backBtn) {
          backBtn.hidden = stack.length <= 1;
        }
      }

      function openDrawer() {
        stack = ['root'];
        drawer.setAttribute('data-state', 'open');
        drawer.setAttribute('aria-hidden', 'false');
        document.body.classList.add('az-drawer-open');
        updateUI();
      }

      function closeDrawer() {
        drawer.setAttribute('data-state', 'closed');
        drawer.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('az-drawer-open');
      }

      function pushPage(pageId) {
        if (!findPage(pageId)) return;
        if (stack[stack.length - 1] === pageId) return;
        stack.push(pageId);
        updateUI();
      }

      function popPage() {
        if (stack.length <= 1) {
          closeDrawer();
          return;
        }
        stack.pop();
        updateUI();
      }

      document.addEventListener('click', function (e) {
        var toggle = e.target.closest('[data-az-mobile-toggle]');
        if (toggle) {
          e.preventDefault();
          e.stopPropagation();
          if (typeof e.stopImmediatePropagation === 'function') {
            e.stopImmediatePropagation();
          }
          var action = toggle.getAttribute('data-az-mobile-toggle');
          if (action === 'open') openDrawer();
          else if (action === 'close') closeDrawer();
        }
      }, true);

      drawer.addEventListener('click', function (e) {
        var openBtn = e.target.closest('[data-az-open]');
        if (openBtn) {
          e.preventDefault();
          e.stopPropagation();
          pushPage(openBtn.getAttribute('data-az-open'));
          return;
        }

        var backBtnClicked = e.target.closest('[data-az-back]');
        if (backBtnClicked) {
          e.preventDefault();
          e.stopPropagation();
          popPage();
          return;
        }
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && drawer.getAttribute('data-state') === 'open') {
          closeDrawer();
        }
      });

      updateUI();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAzDrawer);
    } else {
      initAzDrawer();
    }

    if (typeof MutationObserver !== 'undefined') {
      var observer = new MutationObserver(function () {
        initAzDrawer();
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  })();


  } catch(e) { console.error(e); }
})();
})();
